const BRACKET_EXPORT_PADDING = 24
const BRACKET_EXPORT_MAX_PIXELS = 16_000_000
const BRACKET_EXPORT_MAX_SIDE = 4096

type BracketExportInput = {
  bracketHeight: number
  bracketWidth: number
  maxPixels?: number
  maxSide?: number
  zoom: number
}

export type BracketExportOptions = {
  backgroundColor: string
  height: number
  includeQueryParams: true
  pixelRatio: number
  style: {
    boxSizing: 'border-box'
    height: string
    left: string
    minHeight: string
    minWidth: string
    position: 'relative'
    top: string
    transform: string
    transformOrigin: 'top left'
    transition: string
    width: string
  }
  width: number
}

export function getBracketExportOptions({
  bracketHeight,
  bracketWidth,
  maxPixels = BRACKET_EXPORT_MAX_PIXELS,
  maxSide = BRACKET_EXPORT_MAX_SIDE,
  zoom,
}: BracketExportInput): BracketExportOptions {
  const exportWidth = bracketWidth + BRACKET_EXPORT_PADDING * 2
  const exportHeight = bracketHeight + BRACKET_EXPORT_PADDING * 2
  const desiredWidth = Math.ceil(exportWidth * zoom)
  const desiredHeight = Math.ceil(exportHeight * zoom)
  // 同时限制 SVG 解码和最终画布，避免大图先在解码阶段耗尽内存。
  const captureScale = Math.min(
    1,
    maxSide / desiredWidth,
    maxSide / desiredHeight,
    Math.sqrt(maxPixels / (desiredWidth * desiredHeight)),
  )
  const width = Math.max(1, Math.floor(desiredWidth * captureScale))
  const height = Math.max(1, Math.floor(desiredHeight * captureScale))
  // 与整数边界同步收紧缩放比例，保证取整后仍容纳完整内容。
  const boundedCaptureScale = Math.min(
    width / desiredWidth,
    height / desiredHeight,
  )
  const pixelRatio = Math.min(
    2,
    maxSide / width,
    maxSide / height,
    Math.sqrt(maxPixels / (width * height)),
  )

  return {
    pixelRatio,
    includeQueryParams: true,
    backgroundColor: '#ffffff',
    width,
    height,
    style: {
      boxSizing: 'border-box',
      position: 'relative',
      left: '0',
      top: '0',
      width: `${exportWidth}px`,
      height: `${exportHeight}px`,
      minWidth: '0',
      minHeight: '0',
      transform: `scale(${zoom * boundedCaptureScale})`,
      transformOrigin: 'top left',
      transition: 'none',
    },
  }
}
